import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LanguageComponent} from "./language.component";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {FormsModule} from "@angular/forms";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {FlexLayoutModule} from "@angular/flex-layout";

@NgModule({
  declarations: [
    LanguageComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatIconModule,
    FlexLayoutModule
  ],
  exports: [
    LanguageComponent
  ],
  providers: [
  ]
})
export class LanguageModule {
}
